// extracted by mini-css-extract-plugin
export default {"outlinedToday":"styles_outlinedToday__eD6h+"};